import {computed, createApp, ref} from "vue";
import SaveModal from "../../components/SaveModal.vue";
import i18n from "@/plugins/i18n";
import {isTablet} from "@/plugins/Helpers";
import {Loader} from '@webstacz/shop-components';
import axios from '@/plugins/axios';

const el = document.createElement('div');
document.body.appendChild(el);
createApp(SaveModal)
    .use(i18n)
    .mount(el);

document.addEventListener('DOMContentLoaded', () => {
    const modals = document.querySelectorAll('.open-product-save-modal');
    for (let button of modals) {
        const config = JSON.parse(button.getAttribute('data-config'));
        const el = document.createElement('div');
        document.body.append(el);

        const app = createApp({
            components: {
                Loader,
            },
            template:
                `
                    <div :class="{'is-responsive': isResponsive}">
                        <Loader :visible="loader"/>
                    </div>
                `,
            setup() {
                const loader = ref(false);

                const isResponsive = computed(() => {
                    return isTablet();
                });

                return {
                    loader,
                    isResponsive,
                };
            },
        });
        const vm = app.mount(el);

        button.addEventListener('click', (e) => {
            e.preventDefault();

            window.openSaveModal(
                {
                    prefillEmail: config.email,
                    woodSamplesUrl: config.woodsamples_url,
                    appointmentUrl: config.appointment_url,
                    type: 'save_modal',
                    requestType: config.request_type,
                    allowAttachments: true,
                    countdownConfig: config.countdown_config
                },
                async (form) => {
                    try {
                        vm.loader = true;

                        const { data } = await axios.post(
                            config.url,
                            {
                                email: form.email,
                                // the product name is the default label, so the
                                // configuration is named even when the customer
                                // never opens the rename field
                                name: config.product_name,
                                parent_configuration_id: config.parent_configuration_id,
                                created_type: form.type,
                                product_id: config.configurable_product_id,
                                special_wish: form.question,
                                terms_and_conditions: form.termsAndConditions,
                                price: config.product_price,
                                recaptcha_score: form.recaptchaScore,
                                ...(form.files?.length && {
                                    files: form.files.map(({filename, content_type, src}) => ({filename, content_type, src})),
                                }),
                            });

                        if (data.status !== 'ok') {
                            throw new Error('Error saving configuration');
                        }

                        pushDataLayersEvent(data.hash, config, form.email, data.id);
                        pushAfterSaveDatalayer(data.after_save_datalayer_event, data.customer_configuration_count, config, form.email, data.id);
                        try {
                            localStorage.setItem('last_configuration', JSON.stringify({
                                identifier: data.hash,
                                createdAt: (new Date()).getTime(),
                            }));
                        } catch (e) {
                            console.error(e);
                        }

                        return {url: data.url, claimToken: data.claim_token};
                    } finally {
                        vm.loader = false;
                    }
                }
            );
        });
    }
});

const pushDataLayersEvent = (configurationHash, config, email, configurationId) => {
    if (typeof document !== 'undefined') {
        const event = new CustomEvent('productSaveModalSentEvent', {
            detail: {
                product_id: config.product_id,
                product_type: config.product_type,
                product_price: config.product_price,
                parent_configuration_id: config.parent_configuration_id,
                configuration: configurationHash,
                email,
                configuration_id: configurationId,
            },
        });
        document.dispatchEvent(event);
    }
};

const pushAfterSaveDatalayer = (datalayerEvent, customerConfigurationCount, config, email, configurationId) => {
    const event = new CustomEvent('productConfigurationAfterSave', {
        detail: {
            event: datalayerEvent,
            product_type: config.product_type,
            product_price: config.product_price,
            configuration_count: customerConfigurationCount,
            email,
            configuration_id: configurationId,
        }
    });
    document.dispatchEvent(event);
}
